import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const groups = [
    {
      title: 'Product & techniek',
      icon: 'Battery',
      questions: [
        {
          q: 'Wat is het verschil tussen grafeen en lithium?',
          a: 'Grafeen-batterijen gebruiken grafeen-elektroden die zorgen voor snellere ionentransport, een langere levensduur (meer laadcycli) en betere prestaties bij lage temperaturen. LFP-lithiumbatterijen zijn een bewezen, veilige technologie met een scherpe prijs per kWh. Beide zijn uitstekende keuzes — het adviesgesprek helpt je bepalen wat het beste bij jouw situatie past.',
        },
        {
          q: 'Hoe veilig is een thuisbatterij in huis?',
          a: 'De GRP-grafeencel heeft bij Kiwa Primara de volledige UN 38.3-testreeks doorstaan: hoogtesimulatie, thermische test, vibratie, schok, kortsluiting, crush en geforceerde ontlading. Dit zijn transportveiligheidstests van de cel. Het complete systeem wordt geïnstalleerd door gecertificeerde monteurs van Uchtman, conform alle geldende Nederlandse normen.',
        },
        {
          q: 'Werkt het met mijn huidige omvormer/panelen?',
          a: 'In de meeste gevallen wel. Tijdens het adviesgesprek beoordelen we jouw huidige installatie en geven we een eerlijk advies. Soms is een aanpassing nodig — dat bespreken we transparant vóór de offerte.',
        },
      ],
    },
    {
      title: 'Installatie',
      icon: 'Wrench',
      questions: [
        {
          q: 'Hoe lang duurt de installatie?',
          a: 'De installatie duurt doorgaans één werkdag. Na het adviesgesprek en de offerte plannen we een installatiedatum die jou uitkomt. [Doorlooptijd te bevestigen met Uchtman]',
        },
        {
          q: 'Heb ik zonnepanelen nodig?',
          a: 'Nee. Een thuisbatterij is ook zonder zonnepanelen interessant. Met een dynamisch energiecontract laad je de batterij op tijdens goedkope daluren en vermijd je duur piekverbruik. Zo profiteer je van marktprijsschommelingen.',
        },
      ],
    },
    {
      title: 'Kosten & besparing',
      icon: 'Calculator',
      questions: [
        {
          q: 'Wat gebeurt er als salderen stopt?',
          a: 'Vanaf 1 januari 2027 mag teruggeleverde zonnestroom niet meer worden weggestreept tegen verbruik. De vergoeding daalt naar minimaal 50% van het kale leveringstarief. Wie nu niets doet, betaalt straks meer voor dezelfde stroom die hij zelf opwekt. Met een thuisbatterij gebruik je die stroom gewoon zelf.',
        },
        {
          q: 'Wat kost onderhoud?',
          a: 'Thuisbatterijen hebben nauwelijks onderhoud nodig. Het systeem wordt bewaakt via het klantenportaal. Bij eventuele storingen is Uchtman bereikbaar voor service. [Onderhoudscontract details te bevestigen]',
        },
        {
          q: 'Welke garantie krijg ik?',
          a: '[GARANTIE — te bevestigen met GRP Energy en Uchtman vóór publicatie]',
        },
      ],
    },
  ];

  let globalIndex = 0;

  return (
    <section id="faq" className="py-16 lg:py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <div className="inline-flex items-center space-x-2 text-primary bg-primary/10 px-3 py-1.5 rounded-full text-xs font-heading font-semibold uppercase tracking-wider mb-4">
            <Icon name="HelpCircle" size={12} />
            <span>Veelgestelde vragen</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-foreground leading-tight">
            Antwoorden op jouw vragen
          </h2>
          <p className="mt-4 font-body text-muted-foreground">
            Staat jouw vraag er niet bij? Stel hem in het gratis adviesgesprek.
          </p>
        </div>

        <div className="space-y-8">
          {groups?.map((group) => (
            <div key={group?.title}>
              <div className="flex items-center space-x-2 mb-4">
                <div className="w-7 h-7 bg-primary/10 rounded-md flex items-center justify-center">
                  <Icon name={group?.icon} size={14} className="text-primary" />
                </div>
                <h3 className="text-sm font-heading font-bold text-foreground uppercase tracking-wider">{group?.title}</h3>
              </div>

              <div className="space-y-2">
                {group?.questions?.map((item) => {
                  const idx = globalIndex++;
                  const isOpen = openIndex === idx;
                  return (
                    <div key={idx} className="bg-white border border-border rounded-xl overflow-hidden shadow-elevation-1">
                      <button
                        onClick={() => setOpenIndex(isOpen ? null : idx)}
                        className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-gray-50 transition-colors"
                        aria-expanded={isOpen}
                      >
                        <span className="text-sm font-heading font-semibold text-foreground pr-4">{item?.q}</span>
                        <Icon
                          name={isOpen ? 'ChevronUp' : 'ChevronDown'}
                          size={16}
                          className={`flex-shrink-0 transition-transform duration-200 ${isOpen ? 'text-primary' : 'text-muted-foreground'}`}
                        />
                      </button>
                      {isOpen && (
                        <div className="px-5 pb-5 border-t border-border/50">
                          <p className="text-sm font-body text-muted-foreground leading-relaxed pt-4">{item?.a}</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
